export default {
  "site.name": "AllChinaBuy Spreadsheet",
  "site.title": "AllChinaBuy Spreadsheet - Products, Sellers & Buying Guides",
  "site.description": "Explore AllChinaBuy spreadsheet resources, product finds, seller research, QC guides, shipping information, warehouse tips and practical buying guides — organized in one easy-to-use resource hub.",
  "nav.spreadsheet": "Spreadsheet",
  "nav.categories": "Categories",
  "nav.guides": "Guides",
  "nav.review": "Review",
  "nav.shipping": "Shipping",
  "nav.qc": "QC",
  "nav.safety": "Safety",
  "nav.faq": "FAQ",
  "nav.home": "Home",
  "nav.shoppingGuide": "Shopping Guide",
  "hero.eyebrow": "ALLCHINABUY SPREADSHEET RESOURCE HUB",
  "hero.title": "AllChinaBuy Spreadsheet — Find Products, Sellers & Buying Guides in One Place",
  "hero.description": "Explore AllChinaBuy spreadsheet resources, product finds, seller research, QC guides, shipping information, warehouse tips and practical buying guides — organized in one easy-to-use resource hub.",
  "hero.cta1": "Explore the AllChinaBuy Spreadsheet",
  "hero.cta2": "Buy It Now",
  "hero.trust": "Independent Resource · Updated Regularly · Multilingual · Safety Guides",
  "categories.title": "Product Categories",
  "categories.description": "Browse our curated product categories and find exactly what you need on AllChinaBuy Spreadsheet.",
  "categories.select": "Select a Category",
  "articles.title": "AllChinaBuy Spreadsheet Guides",
  "articles.description": "Comprehensive guides and resources to help you navigate the AllChinaBuy Spreadsheet experience.",
  "articles.readMore": "Read Guide",
  "cta.title": "Ready to Start Shopping?",
  "cta.description": "Visit the main AllChinaBuy Spreadsheet website to explore products, compare prices, and make your purchase with confidence.",
  "cta.mainSite": "Visit AllChinaBuy Spreadsheet",
  "cta.buyNow": "Buy It Now",
  "footer.spreadsheet": "Spreadsheet",
  "footer.categories": "Categories",
  "footer.sellers": "Sellers",
  "footer.guides": "Guides",
  "footer.review": "Review",
  "footer.shipping": "Shipping",
  "footer.qc": "QC",
  "footer.warehouse": "Warehouse",
  "footer.safety": "Safety",
  "footer.resources": "Resources",
  "footer.articles": "Articles",
  "footer.faq": "FAQ",
  "footer.comparisons": "Comparisons",
  "footer.company": "Company",
  "footer.about": "About",
  "footer.contact": "Contact",
  "footer.privacy": "Privacy Policy",
  "footer.terms": "Terms of Service",
  "footer.disclaimer": "AllChinaBuySpread is an independent informational resource and is not the official AllChinaBuy website.",
  "footer.language": "Language",
  "lang.en": "English",
  "lang.fr": "Français",
  "lang.de": "Deutsch",
  "lang.da": "Dansk",
  "article.published": "Published",
  "article.readTime": "min read",
  "article.backToHome": "Back to Home",
  "article.relatedArticles": "Related Articles",
  "article.tableOfContents": "Table of Contents",
  "whatIs.title": "What Is AllChinaBuy Spreadsheet?",
  "whatIs.description": "AllChinaBuy Spreadsheet is a comprehensive resource hub designed to help shoppers navigate the complex world of international purchasing. We curate product listings, seller reviews, shipping guides, and quality control information to make your buying experience seamless and secure.",
  "trust.title": "Why Trust AllChinaBuy Spreadsheet?",
  "trust.item1": "Independent resource with no affiliation to sellers",
  "trust.item2": "Regularly updated product categories and pricing",
  "trust.item3": "Multilingual support for global shoppers",
  "trust.item4": "Comprehensive safety and QC guides",
  "seo.article1.title": "AllChinaBuy Spreadsheet Complete Guide",
  "seo.article1.desc": "A comprehensive guide to using AllChinaBuy Spreadsheet for product research, price comparison, and finding trusted sellers.",
  "seo.article1.date": "August 2026",
  "seo.article1.readTime": "8",
};